export enum MedicationFilter {
  CURRENT = "current",
  LOG = "log",
  HISTORY = "history",
  PENDING_SIGNATURE = "pending-signatures",
}

export const getResidentMedicationRoute = (
  id: string,
  filter: MedicationFilter,
) =>
  filter === MedicationFilter.CURRENT
    ? `/residents/${id}/medications`
    : `/residents/${id}/medications/${filter}`;

export const MEDICATION_FILTER_LABELS: Record<MedicationFilter, string> = {
  [MedicationFilter.CURRENT]: "Current Medications",
  [MedicationFilter.LOG]: "Medication Log",
  [MedicationFilter.HISTORY]: "Medication History",
  [MedicationFilter.PENDING_SIGNATURE]: "Pending Sign-Offs",
};
